import DIApi from './_diApi';

class BankInfoCategoryAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BankInfoCategorys';
}

export default new BankInfoCategoryAPI();
